// extracted by mini-css-extract-plugin
export default {"root":"EA7vr7B1TClaJdwcR0h9","placeHolderShimmer":"QxX44JYVsV2wVBYXR__W"};